/**
 * Empty marker directive for notification icons
 */
import {
  Directive
} from '@angular/core';

@Directive({
  selector: '[tdWbNotificationIcon]'
})
export class NotificationIconDirective {

}
